import styled from 'styled-components';

export const CertifyWrapper = styled.div`
  background: linear-gradient(135deg, #f0f4f8 0%, #e8f1f5 100%);
  min-height: calc(100vh - 70px);
  
  .main-container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 24px;
  }

     .page-header {
     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
     border-radius: 12px;
     padding: 20px 24px;
     color: white;
     box-shadow: 0 4px 20px rgba(102, 126, 234, 0.25);
     position: relative;
     overflow: hidden;
     
     &::before {
       content: '';
       position: absolute;
       top: -50%;
       right: -50%;
       width: 100%;
       height: 100%;
       background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%);
       pointer-events: none;
     }
     
     .header-content {
       position: relative;
       z-index: 1;
       display: flex;
       align-items: center;
       justify-content: space-between;
       gap: 24px;
       
       @media (max-width: 768px) {
         flex-direction: column;
         text-align: center;
         gap: 16px;
       }
     }
      
     .header-left {
       flex: 1;
       
       .header-title {
         color: white !important;
         margin-bottom: 4px !important;
         font-weight: 600;
         font-size: 24px;
         line-height: 1.3;
         
         @media (max-width: 768px) {
           font-size: 20px;
         }
       }
       
       .header-subtitle {
         color: rgba(255, 255, 255, 0.85);
         font-size: 14px;
         margin: 0;
         line-height: 1.4;
         font-weight: 400;
         
         @media (max-width: 768px) {
           font-size: 13px;
         }
       }
     }
     
     .header-right {
       display: flex;
       flex-direction: column;
       align-items: flex-end;
       gap: 8px;
       
       @media (max-width: 768px) {
         align-items: center;
         width: 100%;
       }
       
       .status-display {
         display: flex;
         align-items: center;
         gap: 12px;
         background: rgba(255, 255, 255, 0.12);
         backdrop-filter: blur(8px);
         border-radius: 30px;
         padding: 8px 16px;
         border: 1px solid rgba(255, 255, 255, 0.15);
         
         .status-icon {
           width: 28px;
           height: 28px;
           border-radius: 50%;
           display: flex;
           align-items: center;
           justify-content: center;
           font-size: 14px;
           background: rgba(255, 255, 255, 0.2);
           
           &.completed {
             background: rgba(82, 196, 26, 0.9);
             color: white;
           }
           
           &.partial {
             background: rgba(250, 173, 20, 0.9);
             color: white;
           }
           
           &.pending {
             background: rgba(140, 140, 140, 0.9);
             color: white;
           }
         }
         
         .status-info {
           display: flex;
           flex-direction: column;
           
           .status-label {
             font-size: 10px;
             color: rgba(255, 255, 255, 0.7);
             margin: 0;
             text-transform: uppercase;
             letter-spacing: 0.3px;
             font-weight: 500;
           }
           
           .status-value {
             font-size: 14px;
             font-weight: 600;
             color: white;
             margin: 0;
           }
         }
       }
       
       .modified-date-display {
         background: rgba(255, 255, 255, 0.08);
         border-radius: 16px;
         padding: 4px 12px;
         font-size: 12px;
         color: rgba(255, 255, 255, 0.8);
         border: 1px solid rgba(255, 255, 255, 0.1);
         
         .date-icon {
           margin-right: 6px;
           opacity: 0.7;
           font-size: 11px;
         }
       }
     }
   }

     .stats-section {
     display: grid;
     grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
     gap: 24px;
     margin-bottom: 8px;
   }

   .stat-card {
     background: white;
     border-radius: 16px;
     padding: 32px;
     box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
     border: 1px solid rgba(230, 236, 241, 0.8);
     transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
     position: relative;
     overflow: hidden;
     cursor: pointer;
     
     &:hover {
       transform: translateY(-4px);
       box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
     }
     
     &.electricity::before {
       content: '';
       position: absolute;
       top: 0;
       left: 0;
       right: 0;
       height: 4px;
       background: linear-gradient(90deg, #faad14, #ffc53d);
     }
     
     &.gas::before {
       content: '';
       position: absolute;
       top: 0;
       left: 0;
       right: 0;
       height: 4px;
       background: linear-gradient(90deg, #ff7875, #ff9c6e);
     }
     
     &.overall::before {
       content: '';
       position: absolute;
       top: 0;
       left: 0;
       right: 0;
       height: 4px;
       background: linear-gradient(90deg, #667eea, #764ba2);
     }
     
     .stat-header {
       display: flex;
       align-items: center;
       justify-content: space-between;
       margin-bottom: 24px;
       
       .stat-title {
         display: flex;
         align-items: center;
         gap: 12px;
         
         .stat-icon {
           width: 48px;
           height: 48px;
           border-radius: 12px;
           display: flex;
           align-items: center;
           justify-content: center;
           font-size: 24px;
           color: white;
           
           &.electricity {
             background: linear-gradient(135deg, #faad14, #ffc53d);
           }
           
           &.gas {
             background: linear-gradient(135deg, #ff7875, #ff9c6e);
           }
           
           &.overall {
             background: linear-gradient(135deg, #667eea, #764ba2);
           }
         }
         
         .stat-name {
           font-size: 20px;
           font-weight: 600;
           color: #2c3e50;
           margin: 0;
         }
       }
       
       .stat-status {
         display: flex;
         align-items: center;
         gap: 8px;
         padding: 6px 12px;
         border-radius: 20px;
         font-size: 12px;
         font-weight: 600;
         
         &.completed {
           background: rgba(82, 196, 26, 0.1);
           color: #52c41a;
         }
         
         &.partial {
           background: rgba(250, 173, 20, 0.1);
           color: #faad14;
         }
         
         &.pending {
           background: rgba(140, 140, 140, 0.1);
           color: #8c8c8c;
         }
       }
     }
     
     .stat-content {
       display: flex;
       align-items: center;
       justify-content: space-between;
       gap: 24px;
       
       .stat-numbers {
         flex: 1;
         
         .main-stats {
           display: flex;
           align-items: baseline;
           gap: 12px;
           margin-bottom: 8px;
           
           .certified-count {
             font-size: 36px;
             font-weight: 700;
             color: #52c41a;
           }
           
           .total-count {
             font-size: 24px;
             font-weight: 600;
             color: #8c8c8c;
           }
           
           .separator {
             font-size: 24px;
             color: #d9d9d9;
           }
         }
         
         .stat-labels {
           display: flex;
           gap: 16px;
           
           .stat-label {
             display: flex;
             align-items: center;
             gap: 4px;
             font-size: 12px;
             color: #8c8c8c;
             
             .label-dot {
               width: 8px;
               height: 8px;
               border-radius: 50%;
               
               &.certified {
                 background: #52c41a;
               }
               
               &.uncertified {
                 background: #8c8c8c;
               }
             }
           }
         }
       }
       
       .stat-progress {
         flex-shrink: 0;
         
         .ant-progress-circle {
           .ant-progress-text {
             font-size: 18px !important;
             font-weight: 700;
           }
         }
       }
     }
     
     .stat-footer {
       margin-top: 20px;
       padding-top: 16px;
       border-top: 1px solid #f0f0f0;
       display: flex;
       align-items: center;
       justify-content: space-between;
       
       .percentage-text {
         color: #5a6c7d;
         font-size: 14px;
       }
       
       .view-details {
         color: #667eea;
         font-size: 14px;
         font-weight: 600;
         display: flex;
         align-items: center;
         gap: 4px;
         
         &:hover {
           color: #764ba2;
         }
       }
     }
   }

  

     .progress-section {
     .custom-steps-container {
       display: flex;
       justify-content: center;
       margin-bottom: 24px;
       padding: 0;
       
       @media (max-width: 768px) {
         margin-bottom: 16px;
       }
     }
     
            .custom-steps {
         display: flex;
         align-items: center;
         width: 100%;
         
         @media (max-width: 768px) {
           flex-direction: column;
           gap: 12px;
         }
       }
     
            .step-item {
         display: flex;
         flex-direction: column;
         align-items: center;
         flex: 1;
         position: relative;
         
         @media (max-width: 768px) {
           flex-direction: row;
           width: 100%;
           text-align: left;
         }
         
         &:not(:last-child)::after {
           content: '';
           position: absolute;
           top: 16px;
           left: 60%;
           right: -40%;
           height: 2px;
           background: linear-gradient(90deg, transparent 0%, #e0e0e0 20%, #e0e0e0 80%, transparent 100%);
           z-index: 1;
           
           @media (max-width: 768px) {
             display: none;
           }
         }
         
         &.completed:not(:last-child)::after {
           background: linear-gradient(90deg, transparent 0%, #52c41a 20%, #52c41a 80%, transparent 100%);
         }
         
         &.active:not(:last-child)::after {
           background: linear-gradient(90deg, transparent 0%, #667eea 20%, #e0e0e0 50%, #e0e0e0 80%, transparent 100%);
         }
         
         .step-circle {
           width: 32px;
           height: 32px;
           border-radius: 50%;
           display: flex;
           align-items: center;
           justify-content: center;
           font-weight: 600;
           font-size: 12px;
           position: relative;
           z-index: 2;
           margin-bottom: 8px;
           transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
           box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
           
           @media (max-width: 768px) {
             width: 28px;
             height: 28px;
             font-size: 11px;
             margin-right: 8px;
           }
           
           &.pending {
             background: #f5f5f5;
             color: #8c8c8c;
             border: 2px solid #e0e0e0;
           }
           
           &.active {
             background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
             color: white;
             border: 2px solid #667eea;
             transform: scale(1.05);
             box-shadow: 0 3px 12px rgba(102, 126, 234, 0.25);
           }
           
           &.completed {
             background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
             color: white;
             border: 2px solid #52c41a;
             
             .step-number {
               display: none;
             }
             
             .step-check {
               display: block;
             }
           }
           
           .step-number {
             display: block;
           }
           
           .step-check {
             display: none;
             font-size: 14px;
             
             @media (max-width: 768px) {
               font-size: 12px;
             }
           }
         }
         
         .step-content {
           margin-top: 8px;
           text-align: center;
           
           @media (max-width: 768px) {
             margin-top: 0;
             text-align: left;
             flex: 1;
           }
           
           .step-title {
             font-size: 12px;
             font-weight: 600;
             margin: 0;
             transition: color 0.3s ease;
             
             @media (max-width: 768px) {
               font-size: 11px;
             }
           }
         }
         
         &.pending .step-content .step-title {
           color: #8c8c8c;
         }
         
         &.active .step-content .step-title {
           color: #667eea;
         }
         
         &.completed .step-content .step-title {
           color: #52c41a;
         }
       }
    
         .step-content {

       text-align: center;
       
       .step-title {
         color: #2c3e50 !important;
         margin-bottom: 12px !important;
         font-weight: 600;
         font-size: 18px;
       }
       
       .step-description {
         color: #5a6c7d;
         font-size: 14px;
         line-height: 1.5;
         margin-bottom: 20px;
       }
       
      .step-actions {
        display: flex;
        justify-content: center;
        gap: 12px;
        flex-wrap: wrap;
        
        .ant-btn {
          border-radius: 8px;
          height: 40px;
          padding: 0 20px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 14px;
        }
        
        .ant-btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          box-shadow: 0 3px 12px rgba(102, 126, 234, 0.25);
          
          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 16px rgba(102, 126, 234, 0.35);
          }
        }
      }
      
      .step-info-box {
        margin-top: 24px;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border-radius: 12px;
        padding: 24px;
        border: 2px solid #e9ecef;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        
        .info-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
          
          &:last-child {
            border-bottom: none;
            padding-bottom: 0;
          }
          
          &:first-child {
            padding-top: 0;
          }
          
          .info-icon {
            font-size: 20px;
            color: #667eea;
            min-width: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .info-content {
            display: flex;
            flex-direction: column;
            gap: 4px;
            flex: 1;
            text-align: left;
            
            .ant-typography {
              margin: 0;
            }
            
            strong {
              font-size: 12px;
              color: #6c757d;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
          }
        }
      }
    }
  }

  .users-section {
    background: white;
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(230, 236, 241, 0.8);
    
    .users-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 24px;
    }
    
    .user-card {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 12px;
      padding: 24px;
      text-align: center;
      border: 2px solid #dee2e6;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      }
      
      .user-avatar {
        margin-bottom: 16px;
        
        .ant-avatar {
          border: 4px solid white;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        }
      }
      
      .user-name {
        font-size: 18px;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 4px !important;
      }
      
      .user-role {
        color: #667eea;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }

  .history-section {
    background: white;
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(230, 236, 241, 0.8);
    
    .ant-collapse {
      background: transparent;
      border: none;
      
      .ant-collapse-item {
        border: 2px solid #dee2e6;
        border-radius: 12px;
        margin-bottom: 16px;
        
        .ant-collapse-header {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-radius: 10px 10px 0 0;
          padding: 16px 24px;
          
          .ant-collapse-arrow {
            color: #667eea;
          }
        }
        
        .ant-collapse-content {
          border-radius: 0 0 10px 10px;
          
          .ant-collapse-content-box {
            padding: 24px;
          }
        }
      }
    }
    
    .timeline-container {
      .ant-timeline {
        .ant-timeline-item {
          padding-bottom: 24px;
          
          .ant-timeline-item-content {
            margin-left: 20px;
          }
        }
      }
      
      .log-item {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border-radius: 12px;
        padding: 20px;
        border: 2px solid #dee2e6;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateX(4px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        }
        
        .log-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          
          .log-user-info {
            display: flex;
            align-items: center;
            gap: 12px;
            
            .ant-avatar {
              border: 2px solid white;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            }
            
            .log-action {
              font-weight: 600;
              color: #2c3e50;
            }
            
            .ant-tag {
              border-radius: 6px;
              font-weight: 600;
            }
          }
          
          .log-date {
            color: #6c757d;
            font-size: 12px;
            font-weight: 500;
          }
        }
        
        .log-content {
          margin-left: 48px;
          
          .log-information {
            color: #495057;
            line-height: 1.6;
          }
          
          .log-reason {
            margin-top: 8px;
            padding: 8px 12px;
            background: rgba(108, 117, 125, 0.1);
            border-radius: 6px;
            font-style: italic;
            color: #6c757d;
          }
        }
      }
    }
  }

  .success-result {
    .ant-result-icon {
      margin-bottom: 16px;
      
      .anticon {
        font-size: 64px;
      }
    }
    
    .ant-result-title {
      color: #2c3e50 !important;
      font-weight: 600;
    }
    
    .ant-result-subtitle {
      color: #5a6c7d;
      font-size: 16px;
      line-height: 1.6;
    }
  }

       @media (max-width: 768px) {
       padding: 16px;
       
       .page-header {
         padding: 16px 20px;
         
         .header-title {
           font-size: 20px !important;
         }
         
         .header-content {
           gap: 12px;
         }
         
         .header-right {
           .status-display {
             padding: 6px 12px;
             gap: 8px;
             
             .status-icon {
               width: 24px;
               height: 24px;
               font-size: 12px;
             }
             
             .status-info .status-value {
               font-size: 12px;
             }
           }
         }
       }
       
       .stats-section {
         grid-template-columns: 1fr;
       }
       
       .stat-card {
         .stat-content {
           flex-direction: column;
           gap: 16px;
           
           .stat-numbers {
             text-align: center;
           }
         }
       }
       
       .users-grid {
         grid-template-columns: 1fr;
       }
       
       .step-actions {
         flex-direction: column;
         align-items: center;
         
         .ant-btn {
           width: 100%;
           max-width: 280px;
         }
       }
     }
`